/* This file is autogenerated, see readme.md for instructions */
import ArchiveAltSvgIcon from '@bloomreach/banana-theme/icons/archive-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArchiveAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArchiveAltSvgIcon />
    </Icon>
  );
});

ArchiveAltIcon.displayName = 'ArchiveAltIcon';

export default ArchiveAltIcon;
